import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { api } from '.';
import { handleApiRequestSuccessData, handleRequestError } from '../utils/request';
export var apiCommonUploadFiles = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var url, formData, params, uploadProcessCallback, uploadCompletedCallback, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = payload.url, formData = payload.formData, params = payload.params, uploadProcessCallback = payload.uploadProcessCallback, uploadCompletedCallback = payload.uploadCompletedCallback;
            _context.prev = 1;
            _context.next = 4;
            return api.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              params: params,
              onUploadProgress: function onUploadProgress(progressEvent) {
                var loaded = progressEvent.loaded,
                    total = progressEvent.total;
                var percent = Math.round(loaded * 100 / total);
                uploadProcessCallback === null || uploadProcessCallback === void 0 ? void 0 : uploadProcessCallback(percent);
              }
            });

          case 4:
            res = _context.sent;
            uploadCompletedCallback === null || uploadCompletedCallback === void 0 ? void 0 : uploadCompletedCallback();
            return _context.abrupt("return", [res.data]);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to upload document: ".concat(message));
            uploadCompletedCallback === null || uploadCompletedCallback === void 0 ? void 0 : uploadCompletedCallback();
            return _context.abrupt("return", [null, _context.t0]);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function apiCommonUploadFiles(_x) {
    return _ref.apply(this, arguments);
  };
}(); // Upload the signature documnet of quote: It is currently only used in great american.

export var apiUploadQuoteRelatedFiles = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/quote_documents", payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function apiUploadQuoteRelatedFiles(_x2) {
    return _ref2.apply(this, arguments);
  };
}(); // Delete the signature documnet of quote: It is currently only used in great american.

export var apiDeleteQuoteRelatedFiles = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.patch("/quote_documents/".concat(payload.quote_document_id), payload);

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiDeleteQuoteRelatedFiles(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiDownloadBrokerListExcelFile = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.get("/brokers/export/csv?".concat(qs.stringify(payload)), {
              responseType: 'blob'
            });

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiDownloadBrokerListExcelFile(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetHiscoxProposalLetterDocumentUrl = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/hiscox_us/quote/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/proposal_letter"));

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiGetHiscoxProposalLetterDocumentUrl(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiDownloadQuoteOrValidationFilerReport = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post('/file_reports/download', payload, {
              responseType: 'blob'
            });

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", [res, null]);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiDownloadQuoteOrValidationFilerReport(_x6) {
    return _ref6.apply(this, arguments);
  };
}();